import Icons from 'components/Icons'
import FAQItem from './item'
import Header from 'components/Typography/Header'
import Paragraph from 'components/Typography/Paragraph'
import { HelpCircle } from 'lucide-react'

const faqs = [
    {
        question: 'SkyPay Nedir?',
        answer: "SkyPay, dijital oyun kredileri ve e-pin kodlarını güvenli, hızlı ve kolay bir şekilde satın almanıza olanak sağlayan profesyonel bir dijital ödeme platformudur. SSL sertifikalı güvenli altyapımız ile 5 dakika içinde anlık teslimat garantisi sunuyoruz."
    },
    {
        question: 'E-pin kodlarım ne kadar sürede teslim edilir?',
        answer: 'SkyPay ile satın aldığınız tüm e-pin kodları 5 dakika içinde e-posta aracılığıyla size teslim edilir. Herhangi bir sorun yaşamanız durumunda e-posta desteğimizden yardım alabilirsiniz.'
    },
    {
        question: 'Hangi ödeme yöntemlerini kullanabilirim?',
        answer: 'Kredi kartı, banka havalesi, EFT, dijital cüzdan ve çeşitli çevrimiçi ödeme yöntemleri ile güvenli şekilde ödeme yapabilirsiniz. Tüm ödeme işlemleri 256-bit SSL şifreleme ile korunur.'
    },
    {
        question: 'Bireysel Üye Olmak İçin Ne Yapmalıyım?',
        answer:
            <ul>
                <li>SkyPay web sitesini ziyaret edin.</li>
                <li>Anasayfada veya menüde bulunan "Üye Ol" veya seçeneğine tıklayın.</li>
                <li>Açılan kayıt formunda istenen bilgileri (isim, soyisim, e-posta adresi, telefon numarası ve şifre) doğru ve eksiksiz olarak doldurun.</li>
                <li>Telefon numaranıza gönderilen doğrulama kodunu girerek telefon numaranızı doğrulayın.</li>
                <li>Kullanıcı sözleşmesini ve gizlilik politikasını inceleyin ve kabul edin.</li>
                <li>"Üye Ol" butonuna tıklayarak üyelik işleminizi tamamlayın.</li>
            </ul>
    },
    {
        question: 'SkyPay hesabının güvenliği nasıl sağlanmaktadır?',
        answer:
            <ul>
                <li>Güvenli sunucular: SkyPay, kullanıcı verilerini güvende tutmak için güvenli sunucular kullanır ve hassas bilgileri şifreler. Bu, bilgilerinizin yetkisiz erişimden korunmasına yardımcı olur.</li>
                <li>SSL sertifikaları: SkyPay web sitesi, SSL (Secure Sockets Layer) sertifikaları kullanarak kullanıcıların bağlantılarını şifreler. Bu sayede, kullanıcıların hesaplarına giriş yaparken ve işlemleri sırasında veri aktarımı güvence altına alınır.</li>
                <li>Şüpheli etkinlik izleme: SkyPay, kullanıcı hesaplarında şüpheli etkinlikleri izlemek ve erken önlem almak için sistemlerini düzenli olarak gözden geçirir. Bu, hesabınıza yetkisiz erişimi önlemeye yardımcı olabilir.</li>
                <li>Müşteri hizmetleri: SkyPay, hesap güvenliği konusunda herhangi bir sorun yaşamanız durumunda size yardımcı olacak bir müşteri hizmetleri ekibine sahiptir. Ekip, hesabınızın güvenliğini sağlamak için size destek sağlayacaktır.</li>        </ul>
    },
    {
        question: "SkyPay'de hesabımı nasıl güvende tutabilirim?",
        answer:
            <ul>
                <li>Güçlü şifreler kullanın: Hesabınızın şifresi, harfler (büyük ve küçük harf), rakamlar ve özel karakterler içeren karmaşık bir kombinasyon olmalıdır. Şifrenizi düzenli aralıklarla değiştirin ve aynı şifreyi başka hesaplarınızda kullanmaktan kaçının.</li>
                <li>Güvenli internet bağlantısı kullanın: Hesabınıza erişirken güvenli ve şifreli bir Wi-Fi ağı kullanın. Açık veya güvensiz Wi-Fi ağları, hesabınızın bilgilerinin çalınma riskini artırabilir.</li>
                <li>Bilgisayarınızı ve mobil cihazlarınızı güncel tutun: İşletim sistemi ve güvenlik yazılımlarınızın en son sürümlerini kullanarak cihazlarınızın güvende olmasını sağlayın. Bu, bilgisayarınıza ve mobil cihazlarınıza zarar vermek isteyen kötü amaçlı yazılımlara karşı koruma sağlar.</li>
                <li>Şüpheli e-postalara ve bağlantılara dikkat edin: SkyPay hesabınızla ilgili olduğunu iddia eden şüpheli e-postalara dikkat edin. SkyPay veya başka bir şirketten gelen e-postaları açmadan önce kimliklerini doğrulayın ve asla şüpheli bağlantılara tıklamayın.</li>
                <li>SkyPay hesabınızın güvenliği ile ilgili herhangi bir sorun yaşarsanız, müşteri hizmetleri ekibine başvurun. Ekip, hesabınızın güvenliğini sağlamak için size yardımcı olacaktır.</li>
            </ul>
    },
    {
        question: 'SkyPay hesap bakiyesi ve işlem hareketleri nereden takip edilir?',
        answer: 'SkyPay hesabınızda bulunan bakiye ve işlem hareketlerini hesabım sayfasından takip edebilirsiniz.'
    },
    {
        question: 'Kimler SkyPay hesabı açamaz?',
        answer: 'SkyPay hesabı; 18 yaşından küçük olan kişiler, yasal yükümlülüklerle sınırlananlar (örneğin iflas etmiş veya yasal takibe uğramış kişiler), kısıtlanmış veya yaptırım uygulanan ülkelerde yaşayanlar ve hizmet koşullarını kabul etmemiş kişiler SkyPay hesabı açamaz. Kısıtlamalar, yasal düzenlemelere ve politikalarına bağlı olarak değişebilir.'
    },
    {
        question: 'Bir kişi birden fazla SkyPay hesabına sahip olabilir mi?',
        answer: 'Bir kişi birden fazla SkyPay hesabı açamaz. Her kişiye ait sadece bir tane SkyPay hesabı olabilir.'
    },
    {
        question: 'SkyPay hesap bilgilerimi nasıl değiştirebilirim?',
        answer: 'SkyPay hesap bilgilerinizi değiştirmek isterseniz, info@SkyPay.com.tr e-posta adresine bir e-posta göndererek SkyPay müşteri desteği ile iletişime geçebilirsiniz. Değişiklik talebinizi ve ilgili hesap bilgilerinizi içeren bir e-posta yazın, ardından müşteri hizmetleri ekibi sizinle iletişime geçerek süreci başlatmanıza ve bilgilerinizi güncellemenize yardımcı olacaktır.'
    },
    {
        question: 'SkyPay hesabımı nasıl kapatabilirim?',
        answer: 'SkyPay hesabınızı kapamak isterseniz, info@SkyPay.com.tr e-posta adresine bir e-posta göndererek SkyPay müşteri desteği ile iletişime geçebilirsiniz. Hesabınızı kapamak istediğinizi belirtin ve müşteri hizmetleri ekibi sizinle iletişime geçerek süreci başlatmanıza ve hesabınızı kapatmanıza yardımcı olacaktır.'
    },
    {
        question: 'SkyPay banka hesabı nasıl eklenir?',
        answer: 'SkyPay hesabınıza banka hesabı eklemek için, hesabım sayfasından banka hesabı ekleme seçeneğine tıklayın. Ardından, eklemek istediğiniz banka hesabını seçin ve sizden istenen bilgileri eksiksiz ve doğru bir şekilde doldurun. Banka hesabınızı ekledikten sonra, hesabım sayfasından banka hesabınızı seçerek işlem yapabilirsiniz.'
    },
    {
        question: 'SkyPay hesabına nereden, nasıl para yüklenir?',
        answer: 'SkyPay hesabına kendinize ait bir banka hesabından sadece havale ve EFT yöntemi ile para yüklenebilmektedir.'
    },
    {
        question: 'SkyPay hesabına kredi kartı ile nasıl para yüklenir?',
        answer: 'SkyPay hesabına kredi kartı ile para yükleme sistemi aktif değildir.'
    },
    {
        question: 'SkyPay ile ilgili öneri ve şikayetler nereye iletilmesi gerekiyor?',
        answer: 'SkyPay ile ilgili öneri ve şikayetleriniz için; info@SkyPay.com.tr e-posta adresine bir e-posta göndererek SkyPay müşteri desteği ile iletişime geçebilirsiniz.'
    },
]

const FAQ = () => {
    return (
        <section id="sss" className='py-24 md:py-40 relative overflow-hidden'>
            <div className='absolute inset-0 bg-gradient-to-br from-primary/5 via-transparent to-secondary/5'></div>
            
            <div className='max-w-7xl mx-auto px-6 relative z-10'>
                <div className='text-center space-y-10 mb-20'>
                    <div className='inline-flex items-center gap-3 px-4 py-2 bg-gradient-to-r from-primary/10 to-secondary/10 rounded-full border border-primary/20'>
                        <Icons className="bg-gradient-to-r from-primary to-secondary p-2 rounded-lg"> 
                            <HelpCircle size={24} className="text-white" /> 
                        </Icons>
                        <span className="text-primary font-semibold text-sm">Merak Ettiklerinizin Cevabı Burada</span>
                    </div>

                    <div className='space-y-6'>
                        <Header level={1} className="text-white text-5xl lg:text-6xl font-bold leading-tight bg-gradient-to-r from-white to-gray-300 bg-clip-text text-transparent">
                            Sıkça Sorulan<br />
                            <span className="bg-gradient-to-r from-primary to-secondary bg-clip-text text-transparent">Sorular</span>
                        </Header>
                        <Paragraph className="text-gray-300 text-xl leading-relaxed max-w-3xl mx-auto">
                            SkyPay dijital ödeme platformu hakkında en çok merak edilen soruların cevapları. Sorularınız için <span className='text-primary font-semibold'>info@SkyPay.com.tr</span> adresinden e-posta ile ulaşabilirsiniz.
                        </Paragraph>
                    </div>
                </div>

                <div className='max-w-4xl mx-auto'>
                    {faqs.map((faq, index) => (
                        <FAQItem key={index} question={faq.question} answer={faq.answer} />
                    ))}
                </div>
            </div>
        </section>
    )
}

export default FAQ